import { combineAuth } from './hr-authority';
import {OrganizationAuthority} from "./organization-authority";

export class CadreAuthority extends OrganizationAuthority {

    public static readonly CADRE_BASE = "cadre";

    constructor(authority: string) {
        super(combineAuth(CadreAuthority.CADRE_BASE, authority));
    }

}
